// extracted by mini-css-extract-plugin
module.exports = {"privacyContainer":"Terms_privacyContainer__uacK1","privacyList":"Terms_privacyList__2NRAA"};